import { Component, type ReactNode } from 'react';
import { Button } from '@/components/ui/button';

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: unknown) {
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="min-h-screen flex items-center justify-center bg-neutral-0 p-8">
          <div className="max-w-md space-y-4 text-center">
            <h1 className="text-xl font-semibold text-neutral-900">Something went wrong</h1>
            <p className="text-sm text-neutral-500">{this.state.error?.message ?? 'Unknown error'}</p>
            <Button onClick={() => window.location.reload()}>Reload</Button>
          </div>
        </main>
      );
    }
    return this.props.children;
  }
}
